import { api } from '~/lib/api.js'

export const saveDay = (payload) => async (dispatch) => {
  dispatch({
    type: 'DAYS_PENDING'
  })

  const data = await api.post('days.json', payload)

  dispatch({
    type: data ? 'NEW_DAY' : 'DAYS_ERROR',
    newDay: data
  })
  if (data?.registration_lists) {
    dispatch({
      type: 'SAVE_REGISTRATION_LISTS',
      registration_lists: data.registration_lists
    })
  }
  return data
}

export const getAllDays = () => async (dispatch) => {
  dispatch({
    type: 'DAYS_PENDING'
  })
  const data = await api.get('days.json')
  data && dispatch({
    type: 'DAYS_SUCCESS',
    allDays: data.days,
    ...data
  })
  return data
}

export const openDay = (dag_id) => async (dispatch) => {
  dispatch({
    type: 'OPEN_DAY',
    dag_id
  })
}

export const updateStatus = (data) => async (dispatch) => {
  const newDay = await api.post('days/update_status.json', data)
  newDay && !newDay.invalidFlights && !newDay.endChecklistIncomplete && dispatch({
    type: 'NEW_DAY',
    newDay
  })

  return newDay
}

export const updateChecklist = ({ dag_id, type, answers, user_id, pincode }) => async (dispatch) => {
  const newDay = await api.post('days/update_checklist.json', { dag_id, type, answers, user_id, pincode })
  newDay && dispatch({
    type: 'NEW_DAY',
    newDay
  })
  return newDay
}

export const getRoosters = () => async (dispatch) => {
  const data = await api.get('rooster.json')
  data && dispatch({
    type: 'ROOSTER_SUCCES',
    data
  })
  return data?.roosters
}

export const saveRooster = (payload) => async (dispatch) => {
  const data = await api.post('rooster/save_rooster.json', payload)
  if (payload.action === 'delete') {
    dispatch({
      type: 'ROOSTER_DELETE',
      rooster_id: payload.id
    })
  } else {
    data && dispatch({
      type: 'ROOSTER_UPDATE',
      rooster: data.rooster
    })
  }
  return data?.rooster
}
